<template>
    <div class="newJournal-view">
        <div class="section-header">
            <h2 class="title-2">
                {{ $t('journal') }}
            </h2>
            <ul class="conventions">
                <li v-for="(con, index) in conventions" :key="index" :class="(con.class)"><v-icon class="icon"
                        icon>fa-circle</v-icon>{{ con.name }}</li>
            </ul>
        </div>
        <div class="section-filters">
            <div class="old-filters">
                <OverallFilters ref="filters"></OverallFilters>
            </div>
            <div class="filters">
                <SwisetSelect v-for="(filter, index) in filters" :ref="filter.ref" :key="index" :label="filter.label"
                    :options="filter.options" :type="filter.type" :selectedValue="filter.selectedValue"
                    :allOption="filter.allOption" :placeholder="filter.placeholder"
                    :changeEvent="filter.changeEvent ? filter.changeEvent : undefined"></SwisetSelect>
            </div>
            <v-overlay @click="(e) => closeOverlay(e)" :dark="false" v-model="overlay">
                <div class="datesContainer">
                    <v-text-field class="v-text-field" v-model="dateRangeText"
                        :label="this.$i18n.messages[this.$i18n.locale].selectedPeriod" readonly disabled></v-text-field>
                    <v-date-picker class="v-date-picker" v-model="dates" range></v-date-picker>
                    <button @click="confirmCustomDates()" :disabled="checkDates">Confirm</button>
                </div>
            </v-overlay>
            <div class="actions">
                <v-btn @click="()=>updateFilters()" class="primary-btn"><svg class="svg-icon" width="18" height="18"
                        viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4.9 11.5578L6.3 12.3356V7.21C6.29923 7.00596 6.22632 6.81042 6.097 6.66556L1.561 1.55556H12.453L7.924 6.66556C7.79468 6.81042 7.72177 7.00596 7.721 7.21L7.7 13.2222L9.1 14V7.52889L13.706 2.33333C13.8903 2.12564 13.9955 1.84714 14 1.55556V0.777778C14 0.571498 13.9263 0.373668 13.795 0.227806C13.6637 0.0819444 13.4857 0 13.3 0H0.7C0.514348 0 0.336301 0.0819444 0.205025 0.227806C0.0737499 0.373668 0 0.571498 0 0.777778V1.55556C0.00447825 1.84714 0.10975 2.12564 0.294 2.33333L4.9 7.52889V11.5578Z"
                            fill="#1B1B1B" />
                    </svg>
                    {{ $t('apply') }}</v-btn>
                <v-btn @click="resetFields()" class="primary-btn"><svg class="svg-icon" width="18" height="18"
                        viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.83692 3.42886H4.13771C4.59544 3.42886 4.96525 3.81185 4.96525 4.28591C4.96525 4.75996 4.59544 5.14295 4.13771 5.14295H0.827542C0.369808 5.14295 0 4.75996 0 4.28591V0.857717C0 0.383663 0.369808 0.000669609 0.827542 0.000669609C1.28528 0.000669609 1.65508 0.383663 1.65508 0.857717V2.22899L2.11023 1.75762C4.37304 -0.585872 8.04008 -0.585872 10.3029 1.75762C12.5657 4.1011 12.5657 7.89889 10.3029 10.2424C8.04008 12.5859 4.37304 12.5859 2.11023 10.2424C1.78697 9.9076 1.78697 9.36391 2.11023 9.02913C2.43349 8.69434 2.95846 8.69434 3.28172 9.02913C4.89801 10.703 7.5177 10.703 9.13399 9.02913C10.7503 7.35521 10.7503 4.64212 9.13399 2.9682C7.5177 1.29428 4.89801 1.29428 3.28172 2.9682L2.83692 3.42886Z"
                            fill="#1B1B1B" />
                    </svg>
                </v-btn>
            </div>
        </div>
        <div class="section-ratios">
            <h3 class="title-3">{{ $t('highlight') }}</h3>
            <div class="ratios-container">
                <RatioCard v-for="(ratio, index) in ratios" :key="index" :chip="ratio.chip" :mainText="ratio.mainText"
                    :subText="ratio.subText" :appColor="ratio.appColor"></RatioCard>
            </div>
        </div>
        <div class="section-tabs">
            <h3 class="title-3">{{ $t('detailed') }}</h3>
            <Tabs :tabs="tabs" />
        </div>
    </div>
</template>
<script>
import Moods from "../moods"
import SwisetSelect from '../../../components/comp-base/SwisetSelect.vue';
import RatioCard from '../components/RatioCard.vue';
import Tabs from '../../../components/Tabs.vue';
import OverallFilters from '../components/OverallFilters.vue';
import Repository from '../../../repositories/journal';

export default {
    name: "NewJournal",
    async mounted() {
        /* eslint-disable no-console */
        this.trades = this.$store.state.book.trades;
        this.$refs.Month[0].selectedValue = this.$i18n.messages[this.$i18n.locale].week;
        this.updateFilters();
    },
    computed: {
        dateRangeText() {
            return this.dates.join(' ~ ')
        },
        checkDates() {
            return !(this.dates.length == 2);
        }
    },
    methods: {
        async updateFilters() {
            let fullFromDate = this.fullFromDateP;
            if (!fullFromDate)
                fullFromDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), this.fromDate.getDate(), 0, 0);
            var month;
            if (this.$refs.Month[0].selectedValue)
                month = this.$refs.Month[0].selectedValue.trim();
            switch (month) {
                case "Ultima semana":
                case "This week":
                    fullFromDate.setDate(fullFromDate.getDate() - 7);
                    break;
                case "Ultimos 30 dias":
                case "Last 30 days":
                    fullFromDate.setDate(fullFromDate.getDate() - 30);
                    break;
                case "Ultimos 60 dias":
                case "Last 60 days":
                    fullFromDate.setDate(fullFromDate.getDate() - 60);
                    break;
                case "Ultimos 90 dias":
                case "Last 90 days":
                    fullFromDate.setDate(fullFromDate.getDate() - 90);
                    break;
                default:
                    break;
            }
            let fullToDate = this.fullToDateP;
            if (!fullToDate)
                fullToDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), this.toDate.getDate(), 0, 0);
            fullToDate.setDate(fullToDate.getDate() + 1);
            let moodsKey = Moods.map(m => m.key);
            if (this.$refs.Moods[0].selectedValue) {
                if (this.$refs.Moods[0].selectedValue !== this.$i18n.messages[this.$i18n.locale].all) {
                    moodsKey = []
                    for (let i = 0; i < this.$refs.Moods[0].selectedValue.length; i++) {
                        moodsKey[i] = Moods.filter((mood) => mood[this.$i18n.locale] === this.$refs.Moods[0].selectedValue[i])[0].key;
                    }
                }
            }
            this.$refs.filters.setFilterMade(true);
            this.$refs.filters.setCurrentFilter({
                fromDate: fullFromDate,
                toDate: fullToDate,
                side: this.$refs.Sides[0].selectedValue ? this.$refs.Sides[0].selectedValue.trim().toUpperCase() : "All",
                mood: moodsKey,
                asset: this.$refs.Assets[0].selectedValue ? this.$refs.Assets[0].selectedValue.map(val => { return this.$store.state.user.assets.filter(asset => (val == asset.assetName))[0].ticker }) : this.$store.state.user.assets.map(asset => (asset.ticker)),
                brokerAccount: this.$refs.Accounts[0].selectedValue ? this.$refs.Accounts[0].selectedValue.map(val => { return this.$store.state.user.brokerAccounts.filter(acc => acc.broker.name + " ~ " + acc.identifier == val)[0].id }) : this.$store.state.user.brokerAccounts.map(acc => (acc.id)),
                result: this.$refs.Results[0].selectedValue ? this.$refs.Results[0].selectedValue : "All",
                strategy: this.$refs.Strategies[0].selectedValue ? this.$refs.Strategies[0].selectedValue.map(val => { return this.$store.state.user.strategies.filter(s => s.name == val)[0].id }) : [],
            });
            this.$refs.filters.callFilter({
                fromDate: fullFromDate,
                toDate: fullToDate,
                side: this.$refs.Sides[0].selectedValue ? this.$refs.Sides[0].selectedValue.trim().toUpperCase() : "All",
                mood: moodsKey,
                asset: this.$refs.Assets[0].selectedValue ? this.$refs.Assets[0].selectedValue.map(val => { return this.$store.state.user.assets.filter(asset => (val == asset.assetName))[0].ticker }) : this.$store.state.user.assets.map(asset => (asset.ticker)),
                brokerAccount: this.$refs.Accounts[0].selectedValue ? this.$refs.Accounts[0].selectedValue.map(val => { return this.$store.state.user.brokerAccounts.filter(acc => acc.broker.name + " ~ " + acc.identifier == val)[0].id }) : this.$store.state.user.brokerAccounts.map(acc => (acc.id)),
                result: this.$refs.Results[0].selectedValue ? this.$refs.Results[0].selectedValue : "All",
                strategy: this.$refs.Strategies[0].selectedValue ? this.$refs.Strategies[0].selectedValue.map(val => { return this.$store.state.user.strategies.filter(s => s.name == val)[0].id }) : [],
            });
            await Repository.analyticsSummary({
                fromDate: fullFromDate,
                toDate: fullToDate,
                side: this.$refs.Sides[0].selectedValue ? this.$refs.Sides[0].selectedValue.trim().toUpperCase() : "All",
                mood: "All",
                asset: "All",
                brokerAccount: "All",
                result: this.$refs.Results[0].selectedValue ? this.$refs.Results[0].selectedValue : "All",
                strategy: "All",
            }).then((response) => {
                if (response.status < 400) {
                    let analytics = response.data;
                    let duration = new Date(analytics.averageDuration * 1000).toISOString().substring(11, 19).split(":")
                    this.ratios = [
                        { chip: (analytics.netProfit >= 0 ? "Profitable" : ""), mainText: (analytics.netProfit >= 0 ? "+$" : "-$") + analytics.netProfit.toFixed(2).toString(), subText: "Net Profit", appColor: "success", tooltip: { text: "Esto es un tootilp de prueba" } },
                        { chip: (analytics.swisetRatio >= 0 ? "Profitable" : ""), mainText: analytics.swisetRatio.toFixed(2), subText: "Swiset Ratio", appColor: "success" },
                        { chip: undefined, mainText: analytics.winRate.toFixed(2).toString() + "%", subText: "Win Rate", appColor: "black" },
                        { chip: undefined, mainText: ("1:") + (analytics.riskReward.toFixed(2)).toString(), subText: "Risk/Reward Ratio", appColor: "black" },
                        { chip: undefined, mainText: analytics.profitFactor.toFixed(2).toString(), subText: "Profit Factor", appColor: "success" },
                        { chip: undefined, mainText: (analytics.profitBestTrade >= 0 ? "+$" : "-$") + analytics.profitBestTrade.toString(), subText: "Best Trade", appColor: "success" },
                        { chip: undefined, mainText: ("-$") + analytics.profitWorstTrade.toString(), subText: "Worst Trade", appColor: "error" },
                        { chip: undefined, mainText: analytics.trades.toString(), subText: "Total Trades", appColor: "black" },
                        { chip: undefined, mainText: duration[0] + "h " + duration[1] + "m " + duration[2] + "s", subText: "Avg. Duration", appColor: "black" },
                        { chip: undefined, mainText: ("$") + analytics.commissions.toFixed(2).toString(), subText: "Total Commissions", appColor: "black" },
                    ]
                }
            });
            this.$router.replace({ query: { startDate: fullFromDate.toISOString().split("T")[0], endDate: fullToDate.toISOString().split("T")[0] } })
        },
        openDateModal() {
            let month = this.$refs.Month[0].selectedValue;
            switch (month) {
                case "Ultima semana":
                case "This week":
                    break;
                case "Ultimos 30 dias":
                case "Last 30 days":
                    break;
                case "Ultimos 60 dias":
                case "Last 60 days":
                    break;
                case "Ultimos 90 dias":
                case "Last 90 days":
                    break;
                default:
                    this.overlay = true;
                    break;
            }
        },
        resetFields() {
            this.$refs.Month[0].selectedValue = undefined;
            this.$refs.Sides[0].selectedValue = undefined;
            this.$refs.Assets[0].selectedValue = undefined;
            this.$refs.Accounts[0].selectedValue = undefined;
            this.$refs.Results[0].selectedValue = undefined;
            this.$refs.Strategies[0].selectedValue = undefined;
            this.$refs.Moods[0].selectedValue = undefined;
            this.updateFilters();
        },
        closeOverlay(e) {
            if (e.target.classList.contains("v-overlay__scrim")) {
                this.overlay = false;
            }
        },
        confirmCustomDates() {
            let fullFromDate = new Date(this.dates[0]);
            let fullToDate = new Date(this.dates[1]);
            let fullFromDateP = new Date(fullFromDate.getFullYear(), fullFromDate.getMonth(), fullFromDate.getDate(), 0, 0);
            let fullToDateP = new Date(fullToDate.getFullYear(), fullToDate.getMonth(), fullToDate.getDate(), 0, 0);
            fullToDate.setDate()
            this.fullFromDateP = fullFromDateP
            this.fullToDateP = fullToDateP;
            this.overlay = false;
        },
    },
    data() {
        return {
            fromDate: new Date(),
            toDate: new Date(),
            trades: [],
            dates: [],
            fullFromDateP: undefined,
            fullToDateP: undefined,
            overlay: false,
            conventions: [{ name: this.$i18n.messages[this.$i18n.locale].profit, class: "green" }, { name: this.$i18n.messages[this.$i18n.locale].loss, class: "red" }, { name: this.$i18n.messages[this.$i18n.locale].normal, class: "black" }],
            filters: [{ ref: "Month", placeholder: this.$i18n.messages[this.$i18n.locale].time, label: this.$i18n.messages[this.$i18n.locale].time, options: [this.$i18n.messages[this.$i18n.locale].week, this.$i18n.messages[this.$i18n.locale].month, this.$i18n.messages[this.$i18n.locale]["60days"], this.$i18n.messages[this.$i18n.locale]["90days"], this.$i18n.messages[this.$i18n.locale]["customPeriod"]], type: 0, selectedValue: undefined, allOption: false, changeEvent: this.openDateModal },
            { ref: "Accounts", placeholder: this.$i18n.messages[this.$i18n.locale].accounts, label: this.$i18n.messages[this.$i18n.locale].accounts, options: this.$store.state.user.brokerAccounts.map(acc => (acc.broker.name + " ~ " + acc.identifier)), type: 1, selectedValue: undefined, allOption: true },
            { ref: "Assets", placeholder: this.$i18n.messages[this.$i18n.locale].assets, label: this.$i18n.messages[this.$i18n.locale].assets, options: this.$store.state.user.assets.map(asset => (asset.assetName)), type: 1, selectedValue: undefined, allOption: true },
            { ref: "Sides", placeholder: this.$i18n.messages[this.$i18n.locale].sides, label: this.$i18n.messages[this.$i18n.locale].sides, options: this.$store.state.sides, type: 0, selectedValue: undefined, allOption: true },
            { ref: "Results", placeholder: this.$i18n.messages[this.$i18n.locale].results, label: this.$i18n.messages[this.$i18n.locale].results, options: this.$store.state.results, type: 0, selectedValue: undefined, allOption: true },
            { ref: "Moods", placeholder: this.$i18n.messages[this.$i18n.locale].moods, label: this.$i18n.messages[this.$i18n.locale].moods, options: Moods.map(m => (m[this.$i18n.locale])), type: 1, selectedValue: undefined, allOption: true },
            { ref: "Strategies", placeholder: this.$i18n.messages[this.$i18n.locale].strategies, label: this.$i18n.messages[this.$i18n.locale].strategies, options: this.$store.state.user.strategies.map(s => (s.name)), type: 1, selectedValue: undefined, allOption: true }
            ],
            ratios: [

            ],
            tabs: [
                { name: this.$i18n.messages[this.$i18n.locale].trades, base: "journal", path: "data", icon: "fa-list" },
                { name: this.$i18n.messages[this.$i18n.locale].statics, base: "journal", path: "stats", icon: "fa-chart-simple" },
                { name: this.$i18n.messages[this.$i18n.locale].calendar, base: "journal", path: "calendar", icon: "fa-calendar" },
            ],
        }
    },
    components: { SwisetSelect, RatioCard, Tabs, OverallFilters }
}
</script>
<i18n>
    {
      "en": {
        "week": "This week",
        "month": "Last 30 days",
        "90days": "Last 90 days",
        "60days":"Last 60 days",
        "customPeriod":"Custom period",
        "time":"Month",
        "strategies": "Strategies",
        "moods":"Moods (All)",
        "assets":"Assets (All)",
        "results":"Results (All)",
        "accounts":"Accounts (All)",
        "sides":"Side (Any)",
        "apply":"Apply",
        "selectedPeriod":"Selected period",
        "profit":"Profit",
        "loss":"Loss",
        "normal":"Normal",
        "highlight":"Your Highlight",
        "detailed":"Detailed data",
        "journal":"Journal trading",
        "trades":"See Trades",
        "statics":"See Statistics",
        "calendar":"See Calendar",
        "all":"All"

      },
      "es": {
        "week": "Ultima semana",
        "month": "Ultimos 30 dias",
        "90days": "Ultimos 90 dias",
        "60days":"Ultimos 60 dias",
        "customPeriod":"Periodo personalizado",
        "time":"Mes",
        "strategies": "Estrategias (Todas)",
        "moods":"Sentimientos (Todos)",
        "assets":"Activos (Todos)",
        "results":"Resultado (Cualquiera)",
        "accounts":"Cuentas (Todas)",
        "sides":"Lado (Cualquiera)",
        "apply":"Aplicar",
        "selectedPeriod":"Periodo seleccionado",
        "profit":"Rentable",
        "loss":"Pérdida",
        "normal":"Normal",
        "highlight":"Resumen",
        "detailed":"Info. detallada",
        "journal":"Bitacora de trading",
        "trades":"Ver Trades",
        "statics":"Ver Estadisticas",
        "calendar":"Ver Calendario",
        "all":"Todo"
      }
    }
</i18n>
<style lang="scss">
.newJournal-view {
    display: flex;
    flex-direction: column;
    margin-right: 40px;
    font-family: "Avenir";
    font-weight: 300;
    font-size: 16px;
    padding-top: 20px;

    .datesContainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: var(--v-baseBackground-base);
        border-radius: 10px;
        padding: 20px;
        color: var(--v-mainBlack-base) !important;

        .v-text-field {
            background-color: var(--v-baseBackground-base);
            color: var(--v-mainBlack-base) !important;
        }

        .v-date-picker {
            .primary {
                background-color: var(--v-mainBtnBackground-base) !important;
                color: var(--v-mainBlack-base) !important;
            }

            .theme--light.v-picker__body,
            .theme--dark.v-picker__body {
                background-color: var(--v-baseBackground-base) !important;
            }

            background-color: var(--v-baseBackground-base);
            color: var(--v-mainBlack-base) !important;

            .v-icon {
                color: var(--v-mainBlack-base) !important;
            }

        }

    }

    .section-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 10px 0;

        .title-2 {
            font-weight: 700;
            font-family: "Product Sans", sans-serif;
            margin: 0;
            color: var(--v-darkGrey-base);
        }

        .conventions {
            list-style-type: none;
            display: flex;

            li {
                font-size: 16px;
                display: flex;
                font-style: normal;
                color: var(--v-mainBlack-base) !important;
                line-height: 1;
                background-color: transparent !important;
                align-items: center;
                margin-left: 50px;

                .icon {
                    font-size: 18px;
                    color: inherit !important;
                    margin-right: 10px;
                }

                &.red {
                    color: var(--v-darkRed-base) !important;
                }

                &.green {
                    color: var(--v-darkGreen-base) !important;
                }

            }

        }
    }

    .section-filters {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin: 0 0;
        flex-wrap: nowrap;
        background-color: var(--v-baseBackground-base);
        top: 48px;
        z-index: 5;
        padding: 15px 0;

        .old-filters {
            display: none;
        }

        .filters {
            width: 85%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            flex-wrap: wrap;
        }

        .actions {
            width: 15%;
            flex-wrap: nowrap;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            color: var(--v-mainBlack-base) !important;
        }
    }

    .title-3 {
        font-size: 17px;
        font-family: "Product Sans", sans-serif;
        color: var(--v-darkGrey-base);
        margin-bottom: 10px;
    }

    .section-ratios {
        .ratios-container {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }

    .btn {
        margin-right: 5px;
        text-overflow: ellipsis;
        display: block;
        text-wrap: nowrap;
        overflow: hidden;
    }

    .v-btn {
        display: flex;
        align-items: center;
        background-color: var(--v-mainBtnBackground-base) !important;
        color: var(--v-mainBlack-base) !important;
        padding: 9px 15px;
        border: 0 !important;
        outline: 0 !important;
        font-size: 16px;
        font-style: normal;
        margin-left: 10px;

        &:first-of-type {
            padding-right: 35px;

            .svg-icon {
                margin-right: 20px;
            }
        }

        .svg-icon {
            path {
                fill: var(--v-mainBlack-base);
            }

            font-size: 20px;
        }

        .icon {
            color: inherit !important;
        }


        &:hover {
            background-color: var(--v-mainBtnBackground-base) !important;
            opacity: 0.8;
        }
    }
}
</style>
